const listeners = new Set();

export function notify(severity, summary, detail) {
  const message = { severity, summary, detail, life: severity === "warn" ? 7000 : 5000 };
  for (const listener of listeners) listener(message);
}

export const notifySuccess = (message) => notify("success", "Listo", message);
export const notifyInfo = (message) => notify("info", "Información", message);
export const notifyWarning = (message) => notify("warn", "Revisa lo siguiente", message);

export function subscribeNotifications(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
